import React from "react";
import { Link } from "react-router-dom";
import { LEGAL_ESTABLISHED_DATE, getDeletionRequestFormUrl } from "../data/siteContact";

// ⚠ この本文はサイト運営者の最終確認を受けていない。公開前に必ず内容を確認すること。
// 利用者に見える場所へ「ドラフト」と書くと規約としての効力に疑義が生じるため、
// 注記は利用者向けには出さず、このコメントで管理する。
const Terms = () => {
  const deletionFormUrl = getDeletionRequestFormUrl();

  return (
    <main className="legal-page" aria-labelledby="terms-title">
      <h1 id="terms-title">利用規約</h1>
      <p>
        この利用規約は、個人が非商用で運営する「Gundam War Portal」
        の利用条件を定めるものです。本サイトはガンダムウォーを楽しむファンのための情報整理を目的とした、非公式ファンサイトです。
      </p>

      <section>
        <h2>利用目的</h2>
        <p>
          利用者は、カード検索、デッキ作成、公開デッキの閲覧、大会情報の確認など、本サイトが提供する機能を個人利用の範囲で利用できます。
          営利目的での無断転載、システムへの過度な負荷、他の利用者や第三者の権利を侵害する行為は禁止します。
        </p>
      </section>

      <section>
        <h2>ログインとアカウント情報</h2>
        <p>
          Googleログインを利用する場合、本サイトはメールアドレス、表示名、アバター画像を取得します。
          これらの情報は、ログイン状態の維持、本人識別、保存デッキや公開デッキの管理、必要な連絡のために利用します。
        </p>
      </section>

      <section>
        <h2>公開コンテンツ</h2>
        <p>
          利用者が公開したデッキ、ニックネーム、大会成績などは、サイト上で他の利用者に表示される場合があります。
          公開する内容には、第三者の個人情報や権利を侵害する情報を含めないでください。
        </p>
      </section>

      <section>
        <h2>Cookie・セッション・アクセス解析</h2>
        <p>
          本サイトは、ログイン状態や表示設定の維持のためにCookie、ローカルストレージ、セッション情報を利用する場合があります。
          また、サイト改善のためにGoogleアナリティクスによるアクセス解析を利用しています。
          詳細と収集を無効にする方法は<Link to="/privacy">プライバシーポリシー</Link>に記載しています。
        </p>
      </section>

      <section>
        <h2>削除依頼</h2>
          <p>
            保存したデッキと公開したデッキは、デッキ構築画面の「読み込み」からご自身で削除できます。
            ニックネームはマイページでいつでも変更でき、過去の大会での表示名も変更後の名前になります。
          </p>
          <p>
            大会の参加記録と、大会に提出したデッキリストは、大会の記録として残るため削除できません。
            他の参加者の成績計算に関わるためです。
          </p>
        {deletionFormUrl ? (
          <p>
            アカウント(メールアドレスとGoogleアカウントとの紐付け)の削除は、
            <a href={deletionFormUrl} target="_blank" rel="noreferrer">
              削除依頼フォーム
            </a>
            からご依頼ください。ご自身で削除する機能がないため、この依頼により対応します。
          </p>
        ) : (
          <p>
            アカウント(メールアドレスとGoogleアカウントとの紐付け)の削除依頼窓口は準備中です。
            正式な窓口を公開するまで、個別対応の方法は別途案内します。
          </p>
        )}
      </section>

      {/* サイト全体のお知らせ機能は無いため、「重要な変更は通知します」とは書かない。
          掲載をもって適用する、という守れる約束だけを書く。 */}
      <section>
        <h2>規約の変更</h2>
        <p>
          本サイトは、機能の追加や運用の変更に応じて、この規約を変更することがあります。
          変更後の規約は、このページに掲載した時点から適用します。
          変更後も本サイトを利用される場合は、変更後の規約に同意したものとみなします。
          規約は随時このページでご確認ください。
        </p>
      </section>

      <section>
        <h2>免責事項</h2>
        <p>
          本サイトの情報は正確性や完全性を保証するものではありません。本サイトの利用により発生した損害について、
          運営者は法令上認められる範囲で責任を負いません。
        </p>
      </section>

      <section>
        <h2>権利表記</h2>
        <p>
          ガンダムは創通・サンライズの登録商標です。本サイトは非公式ファンサイトであり、
          創通、サンライズ、その他権利者とは関係ありません。
        </p>
      </section>

      <p className="legal-page-date">制定日: {LEGAL_ESTABLISHED_DATE}</p>
    </main>
  );
};

export default Terms;
